import { render, staticRenderFns } from "./CmgGuacModeVerified.vue?vue&type=template&id=047e0efd&scoped=true&lang=pug"
import script from "./cmg-guac-mode-verified.ts?vue&type=script&lang=ts&external"
export * from "./cmg-guac-mode-verified.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGuacModeVerified.vue?vue&type=style&index=0&id=047e0efd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e0efd",
  null
  
)

export default component.exports